import { render, staticRenderFns } from "./CustomDropAction.vue?vue&type=template&id=97bbb97e&scoped=true"
import script from "./CustomDropAction.vue?vue&type=script&lang=js"
export * from "./CustomDropAction.vue?vue&type=script&lang=js"
import style0 from "./CustomDropAction.vue?vue&type=style&index=0&id=97bbb97e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbb97e",
  null
  
)

export default component.exports